import * as React from 'react';
import { LinkButton } from '@cian/ui-kit';
import { IconCommunicationPhone16 } from '@cian/ui-kit-design-tokens/icons';
import { useSelector } from 'react-redux';
import { ContactsListCallButton } from './ContactsListCallButton';
import { trackShowPhone } from './tracking';
import { ContactsList } from '../../../components/PromoDetailsModal/components/ContactsList';
import { SingleContactWrapper } from '../../../components/PromoDetailsModal/components/SingleContactWrapper';
import { getGaGeoLabel, getNewbuildingId } from '../../../selectors/newbuilding';
import { getCianMortgagePromoUrl } from '../../../utils/config';
import { IAvailableContacts, IPromoInfoSchema } from '../../../types/promo';
import { useApplicationContext } from '../../../utils/applicationContext';

export interface IActionButtonContainerProps {
  onMortgageClick?(): void;
  cianMortgage: boolean;
  hasContacts: boolean;
  promo: IPromoInfoSchema;
  avaliableContacts: IAvailableContacts;
}

export const ActionButtonContainer: React.FC<IActionButtonContainerProps> = props => {
  const { cianMortgage, hasContacts, onMortgageClick, promo, avaliableContacts } = props;
  const { config } = useApplicationContext();
  const gaLabel = useSelector(getGaGeoLabel);
  const cianMortgageLink = getCianMortgagePromoUrl(config);
  const newbuildingId = useSelector(getNewbuildingId);

  const singleContact = React.useMemo(() => {
    return avaliableContacts.builders[0] || avaliableContacts.sellers[0];
  }, [avaliableContacts]);

  const singleContactLabel = React.useMemo(() => {
    return avaliableContacts.builders.length ? 'Контакты застройщика' : 'Контакты продавца';
  }, [avaliableContacts]);

  const beforeIcon = React.useMemo(() => {
    return avaliableContacts.builders.length ? <IconCommunicationPhone16 color="icon-inverted-default" /> : undefined;
  }, [avaliableContacts]);

  const onShowPhoneClick = React.useCallback(() => {
    trackShowPhone(gaLabel, promo, newbuildingId);
  }, [gaLabel, promo, newbuildingId]);

  if (cianMortgage) {
    return (
      <LinkButton href={cianMortgageLink} onClick={onMortgageClick} theme="fill_secondary" size="M" fullWidth>
        Получить ипотеку онлайн
      </LinkButton>
    );
  }

  if (!hasContacts) {
    return null;
  }

  if (avaliableContacts.builders.length + avaliableContacts.sellers.length > 1) {
    return (
      <ContactsList
        builders={avaliableContacts.builders}
        sellers={avaliableContacts.sellers}
        onShowPhoneClick={onShowPhoneClick}
      />
    );
  }

  return (
    <SingleContactWrapper>
      <ContactsListCallButton
        onClick={onShowPhoneClick}
        beforeIcon={beforeIcon}
        buttonText={singleContactLabel}
        contact={singleContact}
      />
    </SingleContactWrapper>
  );
};
